import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Category, CategoryState } from "@/types/organization";

const initialState: CategoryState = {
  categories: [],
  category: null,
  isFetched: false,
};

export const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    addCategory: (state, action: PayloadAction<Category>) => {
      const newCategory: Category = {
        ...action.payload,
      };
      state.categories.push(newCategory);
    },
    setCategory: (state, action: PayloadAction<Category>) => {
      state.category = action.payload;
      state.isFetched = true;
    },

    setCategories: (state, action: PayloadAction<Category[]>) => {
      state.categories = action.payload;
      state.isFetched = true;
    },
    updateCategory: (state, action: PayloadAction<Category>) => {
      const index = state.categories.findIndex(
        (category) => category.id === action.payload.id,
      );
      if (index !== -1) {
        Object.assign(state.categories[index], action.payload);
      }
    },

    deleteCategory: (state, action: PayloadAction<number>) => {
      state.categories = state.categories.filter(
        (category) => category.id !== action.payload,
      );
    },
  },
});

export const { addCategory, updateCategory, deleteCategory, setCategories } =
  categorySlice.actions;

export default categorySlice.reducer;
